<template>
  <info-header-card
    :icon="work_group.icon()"
    :header="`Work Group ${work_group.name} details`"
    :rows="rows"
    class="animated fadeIn mt-3"
  />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import WorkGroupModel from "@/models/lab/WorkGroupModel";

export default {
  name: "WorkGroupCard",
  components: { InfoHeaderCard },
  props: {
    work_group: {
      type: Object,
      default: () => new WorkGroupModel()
    }
  },
  computed: {
    rows() {
      return [
        {
          label: "Name",
          value: this.work_group.name
        },
        {
          label: "Description",
          value: this.work_group.description || "Not specified"
        }
      ];
    }
  }

}
</script>